import {OnlyTextHeaderArg} from "@psdk/frame-father";

export class CForm extends OnlyTextHeaderArg<CForm> {
  header(): string {
    return 'FORM';
  }
}
